<div class="debug-button-container">
  <button tooltip="Click to report issue" placement="top" (click)="sendDebugRequest()" type="button"
    class="btn btn-default btn-report">
    <i class="fas fa-bug"></i>
  </button>
</div>